import styled from 'styled-components';

export const SelfieContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 32px;
    padding-top: 16px;

    .doc-type {
        display: flex;
    }

    .main {
        margin-top: 16px;
        height: 100%;
        flex: 1;

        ${(props) => props.theme.breakpointTo.sm} {
            margin-top: 0;
        }
    }

    .language-selector {
        width: 160px;
    }
`;
